// Libs

import * as framework from '@src/js/framework.min.js';
import '@src/js/lazy-load';
import '@src/js/iframe';
import '@partials/header/header';


// Плавный скоролл до якорей
$("body").on('click', '[href*="#"]', function(e){
    var fixed_offset = 50;
    $('html,body').stop().animate({ scrollTop: $(this.hash).offset().top - fixed_offset }, 1000);
    e.preventDefault();
});







